import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";

const LOGO = "/logo.webp";

export default function Footer() {
  return (
    <footer className="section--dark" style={{ paddingBlock: 72 }} data-testid="site-footer">
      <div className="container-x on-dark">
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 40 }} className="footer-grid">
          <div>
            <div style={{ display: "inline-flex", alignItems: "center" }}>
              <img src={LOGO} alt="Kunova Impex" style={{ height: 64, width: "auto", background: "#fff", borderRadius: 12, padding: 10 }} />
            </div>
            <p className="muted" style={{ marginTop: 18, maxWidth: 380, lineHeight: 1.7 }}>
              Towel Manufacturers &amp; Global Exporters. Manufactured at our family-owned textile facility since 2006. Exported worldwide by Kunova Impex.
            </p>
          </div>

          <div className="footer-cols">
            <div>
              <h4 style={{ fontSize: 16, marginBottom: 14 }}>Company</h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 10 }}>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/manufacturing">Manufacturing Facility</Link></li>
                <li><Link to="/quality">Quality Control</Link></li>
                <li><Link to="/markets">Export Markets</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
              </ul>
            </div>
            <div>
              <h4 style={{ fontSize: 16, marginBottom: 14 }}>Products</h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 10 }}>
                <li><Link to="/products?cat=bath">Bath Towels</Link></li>
                <li><Link to="/products?cat=hotel">Hotel Towels</Link></li>
                <li><Link to="/products?cat=beach">Beach Towels</Link></li>
                <li><Link to="/products?cat=gym-spa">Gym &amp; Spa</Link></li>
                <li><Link to="/customization">Customization</Link></li>
              </ul>
            </div>
            <div>
              <h4 style={{ fontSize: 16, marginBottom: 14 }}>Contact</h4>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 12 }}>
                <li>
                  <a href="https://wa.me/919699594988" target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                    <Icon name="whatsapp" size={18} /> +91 96995 94988
                  </a>
                </li>
                <li>
                  <a href="mailto:info@kunovaimpex.com" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                    <Icon name="mail" size={18} /> info@kunovaimpex.com
                  </a>
                </li>
                <li>
                  <Link to="/faq">FAQ</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr style={{ border: "none", borderTop: "1px solid rgba(255,255,255,0.12)", margin: "40px 0 20px" }} />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 16, justifyContent: "space-between", alignItems: "center", fontSize: 15 }}>
          <span className="muted">© {new Date().getFullYear()} Kunova Impex. Established 2006. All rights reserved.</span>
          <div style={{ display: "flex", gap: 20 }}>
            <Link to="/privacy" className="muted">Privacy</Link>
            <Link to="/terms" className="muted">Terms</Link>
            <Link to="/sitemap" className="muted">Sitemap</Link>
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 900px) {
          .footer-grid { grid-template-columns: 1.2fr 2fr !important; gap: 60px !important; }
        }
        .footer-cols { display: grid; grid-template-columns: 1fr; gap: 32px; }
        @media (min-width: 600px) {
          .footer-cols { grid-template-columns: repeat(3, 1fr); }
        }
      `}</style>
    </footer>
  );
}
